module.exports = __webpack_public_path__ + "img/Z85-X18-中_05.967ca618.jpg";